<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Timeline</h5>
                  </div>
                  <small class="text-truncate text-muted">NEWS FEED</small>
                </div>
              </div>
            </div>

          </div> <!-- .row end -->

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- activity -->
          <div class="row">
            <div class="col-12">
              <ol class="activity-feed p-0 ms-3 mb-0 pt-5">
                <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="3 hours ago" data-color="green">
                  <div class="card mb-5">
                    <div class="card-body">
                      <input type="checkbox" id="expand_1" name="expand_1">
                      <label for="expand_1" class="mb-0">
                        <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                      </label>
                      <div class="feed-content">
                        <div class="px-4">
                          <blockquote>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat nisi ut
                            ullamcorper congue. Ut tempus egestas mauris et scelerisque. Sed tincidunt ante ligula, eget
                            pharetra mi pretium eget. Fusce tincidunt, elit blandit semper sollicitudin, sapien lectus
                            lobortis quam, ac bibendum lectus risus quis lectus.</blockquote>
                          <blockquote>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat nisi ut
                            ullamcorper congue. Ut tempus egestas mauris et scelerisque. Sed tincidunt ante ligula, eget
                            pharetra mi pretium eget. Fusce tincidunt, elit blandit semper sollicitudin, sapien lectus
                            lobortis quam, ac bibendum lectus risus quis lectus.</blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="3 hours ago" data-color="blue">
                  <div class="card mb-5">
                    <div class="card-body">
                      <input type="checkbox" id="expand_2" name="expand_2">
                      <label for="expand_2" class="mb-0">
                        <b>Aliquam</b> non diam <b>consectetur.</b>
                      </label>
                      <div class="feed-content">
                        <article class="media mb-0">
                          <div class="me-3">
                            <img class="rounded" src="assets/images/xs/avatar4.jpg" alt="">
                          </div>
                          <div class="media-body">
                            <div class="content">
                              <p class="h6">John Smith <small>@johnsmith</small></p>
                              <p>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat nisi ut
                                ullamcorper congue.</p>
                            </div>
                            <nav class="d-flex text-muted font-13">
                              <a href="#" class="icon me-3"><i class="me-1 zmdi zmdi-replay"></i></a>
                              <a href="#" class="icon me-3"><i class="me-1 zmdi zmdi-twitter"></i>24</a>
                              <a href="#" class="icon me-3"><i class="me-1 zmdi zmdi-favorite"></i>43</a>
                              <a href="#" class="text-muted ms-auto">5 notes</a>
                            </nav>
                          </div>
                        </article>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="4 hours ago" data-color="red">
                  <div class="card mb-5">
                    <div class="card-body">
                      <input type="checkbox" id="expand_3" name="expand_3">
                      <label for="expand_3" class="mb-0">
                        <b>Nullam</b> mollis massa ut <b>egestas viverra.</b>
                      </label>
                      <div class="feed-content">
                        <img src="assets/images/gallery/1.jpg" alt="" />
                      </div>
                    </div>
                  </div>
                </li>
                <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="6 hours ago" data-color="green">
                  <div class="card mb-5">
                    <div class="card-body">
                      <label for="expand_4" class="mb-0">
                        <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                        <br>
                        Donec quis felis libero.
                        <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                        <br>
                        Donec quis felis libero.
                        <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                        <br>
                        Donec quis felis libero.
                      </label>
                    </div>
                  </div>
                </li>
                <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="7 hours ago" data-color="yellow">
                  <div class="card mb-5">
                    <div class="card-body">
                      <input type="checkbox" id="expand_5" name="expand_5">
                      <label for="expand_5" class="mb-0">
                        <b>Pellentesque accumsan</b> ligula a tincidunt <b>venenatis.</b>
                      </label>
                      <div class="feed-content">
                        <h2>BOOM!</h2>
                      </div>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
